<template>
  <section class="detail-section">
    <div class="section-title">
      任务信息
    </div>
    <dl class="task-description">
      <div class="task-field task-field-full">
        <dt>任务名称</dt>
        <dd>{{ task.taskName || task.workContent || '-' }}</dd>
      </div>
      <div class="task-field">
        <dt>状态</dt>
        <dd>
          <el-tag
            :type="getStatusType(task.status)"
            size="small"
          >
            {{ task.statusName || task.status || '-' }}
          </el-tag>
          <el-tag
            v-if="task.hasFault === 1"
            type="danger"
            size="small"
            class="fault-tag"
          >
            有异常
          </el-tag>
        </dd>
      </div>
      <div class="task-field">
        <dt>工作类型</dt>
        <dd>
          <el-tag
            v-if="task.workType === 'zyrw'"
            type="danger"
            size="small"
          >
            重要任务
          </el-tag>
          <span v-else>{{ task.workTypeName || '日常任务' }}</span>
        </dd>
      </div>
      <div class="task-field">
        <dt>截止日期</dt>
        <dd>{{ formatDate(task.deadlineDate) }}</dd>
      </div>
      <div class="task-field">
        <dt>所属区域</dt>
        <dd>{{ task.areaPath || task.zoneAreaName || '-' }}</dd>
      </div>
      <div class="task-field task-field-full">
        <dt>具体位置</dt>
        <dd>{{ task.workLocation || '-' }}</dd>
      </div>
      <div class="task-field task-field-full">
        <dt>工作内容</dt>
        <dd><span class="text">{{ task.workContent || '-' }}</span></dd>
      </div>
      <div class="task-field task-field-full">
        <dt>备注说明</dt>
        <dd><span class="text">{{ task.remark || '-' }}</span></dd>
      </div>
      <div class="task-field">
        <dt>执行{{ task.assignType === 'team' ? '小组' : '人员' }}</dt>
        <dd>{{ task.assignUserNames || task.assignTeamName || '未指定' }}</dd>
      </div>
      <div class="task-field">
        <dt>创建人</dt>
        <dd>{{ task.createUserName || '-' }}</dd>
      </div>
      <div
        v-if="task.executeTime"
        class="task-field"
      >
        <dt>是否异常</dt>
        <dd>{{ task.hasFault === 1 ? '有异常' : '正常' }}</dd>
      </div>
      <div
        v-if="task.executeTime"
        class="task-field"
      >
        <dt>执行人</dt>
        <dd>{{ task.executeUserName || '-' }}</dd>
      </div>
      <div
        v-if="task.executeTime"
        class="task-field"
      >
        <dt>完成时间</dt>
        <dd>{{ formatTime(task.executeTime) }}</dd>
      </div>
      <div
        v-if="task.executeTime"
        class="task-field task-field-full"
      >
        <dt>完成情况</dt>
        <dd><span class="text">{{ task.workResult || '-' }}</span></dd>
      </div>
      <div
        v-if="task.faultDesc"
        class="task-field task-field-full"
      >
        <dt>异常情况</dt>
        <dd><span class="text">{{ task.faultDesc }}</span></dd>
      </div>
    </dl>
  </section>
</template>

<script>
import { formatDate, formatDateTime } from '@/features/common/utils/dateTimeUtil';

export default {
  name: 'DailyTaskInfo',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatTime: formatDateTime,
    formatDate,
    getStatusType (status) {
      return { pending: 'warning', completed: 'success' }[status] || '';
    }
  }
};
</script>

<style scoped>
.detail-section {
  margin-bottom: 16px;
}
.section-title {
  margin-bottom: 14px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  color: #303133;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.1;
}
.task-description {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
  overflow: hidden;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-radius: 6px;
  font-size: 14px;
}
.task-field {
  display: flex;
  min-width: 0;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
.task-field-full {
  grid-column: 1 / -1;
}
.task-field dt {
  display: flex;
  flex: 0 0 120px;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 6px 10px 12px;
  background: #f8f9fb;
  color: #606266;
  font-weight: 500;
}
.task-field dd {
  min-width: 0;
  margin: 0;
  padding: 10px 12px;
  overflow-wrap: anywhere;
  color: #303133;
  line-height: 1.6;
}
.text {
  white-space: pre-wrap;
  word-break: break-word;
}
.fault-tag {
  margin-left: 8px;
}
</style>
